import React, {
  useEffect,
  useState,
} from 'react';
import {
  useQuery,
} from '@tanstack/react-query';
import Badge from '@mui/material/Badge';
import clsx from 'clsx';
import {
  NotificationIcon,
} from 'core/icons';
import {
  getApiSettingsHasUnseenUserMessages,
} from 'endpoints';
import isNil from 'lodash/isNil';
import {
  UserMessageStateUpdatedNotificationDTO,
} from 'dtos/userMessageStateUpdatedNotificationDTO';
import useSignalREffect from 'views/EMR/hooks/signalR';

type Props = {
  className?: string;
  data?: { expanded?: boolean };
};

function useInboxHasUnseenMessages() {
  return useQuery<boolean, Error>({
    queryKey: ['inbox-has-unseen-messages'],
    queryFn: getApiSettingsHasUnseenUserMessages,
  });
}

export default function InboxIndicator({
  className,
  data,
}: Props) {
  const [hasUnseenMessages, setHasUnseenMessages] = useState(false);
  const isExpanded = data?.expanded ?? false;
  const {
    data: initialData,
    isLoading,
  } = useInboxHasUnseenMessages();

  useSignalREffect('OnUserMessageStateUpdated', ({ hasNewMessages }: UserMessageStateUpdatedNotificationDTO) => {
    setHasUnseenMessages(hasNewMessages ?? false);
  });

  useEffect(() => {
    if (!isNil(initialData) && !isLoading) {
      setHasUnseenMessages(initialData);
    }
  }, [initialData, isLoading]);

  return (
    <Badge
      variant="dot"
      color="error"
      invisible={isExpanded || !hasUnseenMessages}
      className="flex items-center w-full"
      sx={{
        '.MuiBadge-badge': {
          minWidth: '0.625rem !important',
          width: '0.625rem',
          height: '0.625rem !important',
          borderRadius: '9999px',
          transform: 'translate(6px, -3px)',
        },
      }}
    >
      <NotificationIcon className={className} />
      <div className={clsx('flex-1 text-xs ml-2 mr-12', { hidden: !isExpanded })}>
        Notifications
      </div>
    </Badge>
  );
}
